export { getChannelShareData as getCallDetails } from "./csd";
